export const validName = (value) => {
  const nameRegex = /^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/;
  return nameRegex.test(value);
};

export const validateEmail = (value) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value);
};

export const validatePwd = (value) => {
  const pwdRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  return pwdRegex.test(value);
};

export const getChatbotPositionStyle = (chatbot_position, isMobile = false) => {
  const position = chatbot_position || 'bottom-right';
  const baseGap = '3rem';

  const positions = {
    'bottom-right': isMobile ? { bottom: baseGap, right: baseGap, transform: 'translateX(-50%)' } : { bottom: baseGap, right: baseGap },
    'bottom-left': isMobile ? { bottom: baseGap, left: baseGap, transform: 'translateX(-50%)' } : { bottom: baseGap, left: baseGap },
    'top-right': isMobile ? { top: baseGap, right: baseGap, transform: 'translateX(-50%)' } : { top: baseGap, right: baseGap },
    'top-left': isMobile ? { top: baseGap, left: baseGap, transform: 'translateX(-50%)' } : { top: baseGap, left: baseGap },
    'middle-top': { top: baseGap, left: '50%', transform: 'translateX(-50%)' },
    'middle-bottom': { bottom: baseGap, left: '50%', transform: 'translateX(-50%)' },
    'right-center': isMobile ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } : { top: '50%', right: baseGap, transform: 'translateY(-50%)' },
    'left-center': isMobile ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } : { top: '50%', left: baseGap, transform: 'translateY(-50%)' },
    'middle-center': { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' },
  };

  return positions[position] || positions['bottom-right'];
};
